import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=0d80e6c3&scoped=true&"
import script from "./Landing.vue?vue&type=script&lang=js&"
export * from "./Landing.vue?vue&type=script&lang=js&"
import style0 from "./Landing.vue?vue&type=style&index=0&id=0d80e6c3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d80e6c3",
  null
  
)

component.options.__file = "Landing.vue"
export default component.exports